import styled from "styled-components";

import breakpoints from "../../../styles/breakpoints";
import Button from "../../atoms/Button";

import { GridHolderItemHalf, GridHolderItemContent } from "../../molecules/GridHolder";
import { safeAreaAbsoluteTop } from "../../../styles/safeArea";

export const ImageSection = styled(GridHolderItemHalf)`
  ${breakpoints.smUp} {
    width: 100%;
  }
`;

export const BodySection = styled(GridHolderItemHalf)`
  ${breakpoints.smUp} {
    width: 100%;
  }
`;

export const BodySectionContent = styled(GridHolderItemContent)`
  ${breakpoints.smUp} {
    padding: 40px !important;
    &:last-child {
      padding-bottom: 120px !important;
    }
  }

  ${breakpoints.mdUp} {
    padding: 40px;
  }
`;

export const CellarBodyCloseBtnImageSection = styled(Button)<{ hideOnMobile?: boolean; icon?: string }>`
  position: absolute;
  width: 30px;
  height: 30px;
  border: none;
  background-color: transparent !important;
  background: url("${(props) => props.icon}") no-repeat 50% 50% / 20px;
  z-index: 10;
  ${breakpoints.smDown} {
    display: ${(props) => (props.hideOnMobile ? "none" : "block")};
  }
  left: 25px;
  /* Tray's first flow child (CellarBottleHolder) sits at y=0 so the
   * coloured hero bg fills the notch; the close button absolute-
   * positions over it and folds in the inset to clear the status bar. */
  ${safeAreaAbsoluteTop(25)}
`;
